import { render, staticRenderFns } from "./bannerlisttab.vue?vue&type=template&id=273db132"
import script from "./bannerlisttab.vue?vue&type=script&lang=js"
export * from "./bannerlisttab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports